import { render } from "./client-service.vue?vue&type=template&id=40ddf51a"
import script from "./client-service.vue?vue&type=script&lang=js"
export * from "./client-service.vue?vue&type=script&lang=js"

import "./client-service.vue?vue&type=style&index=0&id=40ddf51a&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__